import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useIpBanCheck = () => {
  const [banned, setBanned] = useState(false);
  const [reason, setReason] = useState<string | null>(null);
  const [checking, setChecking] = useState(true);
  const [ip, setIp] = useState<string | null>(null);

  useEffect(() => {
    const check = async () => {
      try {
        const { data, error } = await supabase.functions.invoke("check-ip-ban");
        if (!error && data?.banned) {
          setBanned(true);
          setReason(data.reason);
          setIp(data.ip);
        }
      } catch {
        // fail open
      } finally {
        setChecking(false);
      }
    };
    check();
  }, []);

  return { banned, reason, checking, ip };
};
